module.exports = "img/camera.2f271b6.svg";